/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{useEffect as e}from"react";import{useLatestValue as t}from"./use-latest-value.js";function n(n,r,s,u){let o=t(s);e((()=>{function e(e){o.current(e)}return(n=null!=n?n:window).addEventListener(r,e,u),()=>n.removeEventListener(r,e,u)}),[n,r,u])}export{n as useEventListener};
//# sourceMappingURL=use-event-listener.js.map
